"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchLogisticsApps = exports.submitOtp = void 0;
var react_hot_toast_1 = require("react-hot-toast");
var api_service_1 = require("../../../api/api_service");
var submitOtp = function (payload, id) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .put({
            endPoint: api_service_1.api_service.api_urls.SUBMIT_OTP + "/".concat(id),
            domain: process.env.SIGN_IN_SIGN_OUT_URL,
            showLoader: true,
            payLoad: payload
        })
            .then(function (response) {
            if (response.status === 200) {
                resolve(response);
                react_hot_toast_1.default.success('The default OTP has been updated successfully', { duration: 2000 });
            }
            else {
                react_hot_toast_1.default.error(response.data.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.message);
            return reject(err);
        });
    });
};
exports.submitOtp = submitOtp;
var fetchLogisticsApps = function () {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .get({
            endPoint: api_service_1.api_service.api_urls.AVAILABLE_APPS,
            domain: process.env.SIGN_IN_SIGN_OUT_URL,
            showLoader: true,
        })
            .then(function (response) {
            if (response.status === 200) {
                return resolve(response.data);
            }
            var erroMessage = response.data
                ? response.data.message
                : 'Unable to process your request.';
            throw new Error(erroMessage);
        })
            .catch(function (err) {
            react_hot_toast_1.default.error(err.message);
            return reject(err);
        });
    });
};
exports.fetchLogisticsApps = fetchLogisticsApps;
